import clsx from 'clsx';
import { isOnPremises } from 'libs/env';
import Link from 'next/link';
import { copyright } from 'pages/pages';
import layoutFooter from './_styles/layout/footer.module.scss';
import layoutMain from './_styles/layout/main.module.scss';
import objectUtilityFlex from './_styles/object/utility/flex.module.scss';
import pageRegistration from './_styles/page/registration.module.scss';

export const SignInFooter = () => {
  return (
    <footer
      className={clsx(layoutFooter['l-footer'], pageRegistration['l-footer'])}
    >
      <div
        className={clsx(
          layoutMain['l-main'],
          pageRegistration['l-main'],
          layoutFooter['l-footer-container']
        )}
      >
        <div
          className={clsx(
            objectUtilityFlex['u-flex'],
            layoutFooter['u-flex'],
            pageRegistration['u-flex']
          )}
        >
          {!isOnPremises() && (
            <ul
              className={clsx(layoutFooter['l-footer-list'], 'list-unstyled')}
            >
              <li>
                <Link href="https://signate.co.jp">運営会社</Link>
              </li>
              <li>
                <span className={layoutFooter['l-footer-list-separator']}>
                  ｜
                </span>
                <Link href="https://signate.co.jp/privacy">
                  プライバシーポリシー
                </Link>
              </li>
            </ul>
          )}
        </div>
        <span className={layoutFooter['l-footer-copy']}>{copyright}</span>
      </div>
    </footer>
  );
};
